import { Action, TableActions, readPermissions } from "../../../features/roles";
import { TableName } from '../../../tables'

export const administrationPermissions = (): TableActions[] => readPermissions().concat([
    { tableName: TableName.ADJUSTMENT_NOTES, actions: [Action.SAVE, Action.REMOVE] },
    { tableName: TableName.CASH_FUNDS, actions: [Action.SAVE, Action.REMOVE] },
    { tableName: TableName.CHECKS, actions: [Action.SAVE, Action.REMOVE] },
    { tableName: TableName.CREDIT_CARDS, actions: [Action.SAVE, Action.REMOVE] },
    { tableName: TableName.CREDIT_PAYMENTS, actions: [Action.SAVE, Action.REMOVE] },
    { tableName: TableName.DRIVERS, actions: [Action.SAVE, Action.REMOVE] },
    { tableName: TableName.EMPLOYEES, actions: [Action.SAVE, Action.REMOVE] },
    { tableName: TableName.EXPENSE_TYPES, actions: [Action.SAVE, Action.REMOVE] },
    { tableName: TableName.EXPENSES, actions: [Action.SAVE, Action.REMOVE] },
    { tableName: TableName.FISCAL_DOCUMENTS, actions: [Action.SAVE, Action.REMOVE] },
    { tableName: TableName.PAYMENT_ORDERS, actions: [Action.SAVE, Action.REMOVE] },
    { tableName: TableName.PAYMENT_TYPES, actions: [Action.SAVE, Action.REMOVE] },
    { tableName: TableName.PURCHASE_ORDERS, actions: [Action.SAVE] },
    { tableName: TableName.SETTINGS, actions: [Action.SAVE] },
    { tableName: TableName.TAXES, actions: [Action.SAVE, Action.REMOVE] },
    { tableName: TableName.TICKETS, actions: [Action.SAVE, Action.REMOVE] },
    { tableName: TableName.TRANSACTIONS, actions: [Action.SAVE, Action.REMOVE] },
    { tableName: TableName.VEHICLES, actions: [Action.SAVE, Action.REMOVE] }
])
